import { StringKeyDictionary } from "../commonInterfaces.js";
import {
    EditableGrid,
    EditableGridProps,
    field,
    InGridButtonClickParams,
    InGridToolBarButton,
    Schema
} from "../core/components/editableGrid/editableGrid.js";
import { ToolBarInGridButtonType } from "../core/components/toolBar.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { LbTravelDay, TravelReportEntity } from "./travelReportInterfaces.js";
import React from "react";

export class TravelDayGrid extends React.Component<TravelDayGridProps, any>{
    translations: StringKeyDictionary<string> = null;
    editableGridRef: EditableGrid;

    constructor(props: any) {
        super(props);
        this.translations = this.props.translations;
    }

    private flag: boolean = false;
    onExpensesGridDataChange = async (action: string, fieldName: string, dataItems: any) => {
        if (action == "itemchange" && !this.flag) {
            let changedDataItem = dataItems[0];
            this.flag = true;
            switch (fieldName) {
                case "Country":
                case "HasBreakfast":
                case "HasLunch":
                case "HasDinner":
                case "HasOvernight":
                    let travelDay: LbTravelDay = changedDataItem;
                    let refreshedData = await this.refreshData(travelDay);
                    changedDataItem.set("Expenses", refreshedData.Expenses);
                    changedDataItem.set("OvernightFlatRate", refreshedData.OvernightFlatRate);
                    break;
            }
            this.flag = false;
        }
        this.props.onChange();
    }

    refreshData = async (travelDay: LbTravelDay): Promise<LbTravelDay> => {
        let ressNr = this.props.entity.RessNr;
        let result = await HTTPService.get<JsonResultClass<LbTravelDay>>("TravelReportEdit/RefreshData?ressNr=" + ressNr, travelDay);
        if (result.Code == 0) {
            travelDay = result.Data;
            return travelDay;
        }
        else
            NotificationHelper.showErrorMessage(result.Message)
    }

    handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "edit":
                p.actions.editSelected();
                break;
        }
    }

    render() {
        let editable = this.props.entity.RecordRight.CanWrite;

        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit" });

        let schema = new Schema();
        schema.Id = "Pos";
        schema.fields["Pos"] = new field("number");
        return <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <EditableGrid id="trDays"
                editable={editable}
                showSelectableCheckBox={true}
                validatable={false}
                data={this.props.data}
                schema={schema}
                gridOptions={this.props.gridOptions}
                resolveAdditionalData={() => { }}
                onDataChanged={this.onExpensesGridDataChange}
                buttons={buttons}
                onButtonClick={this.handleButtonClick}
                gridDetails={{
                    useFeature: true
                }}
                ref={(ref) => this.editableGridRef = ref}
                {...this.props} />
        </div>
    }
}

export interface TravelDayGridProps extends EditableGridProps{
    entity: TravelReportEntity;
    data: LbTravelDay[];
    gridOptions: any;
    translations: StringKeyDictionary<string>;
    onChange?: () => void;
}